module.exports = __webpack_public_path__ + "img/photo3_9.43f06360.jpg";